import { render, staticRenderFns } from "./ColorFilter.vue?vue&type=template&id=8dc67ce2"
import script from "./ColorFilter.vue?vue&type=script&lang=js"
export * from "./ColorFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports